import React, { useEffect } from 'react';
import { useRecoilState } from 'recoil';
import { Subject } from 'rxjs';
import { debounceTime, filter, throttleTime } from 'rxjs/operators';
import { textLayoutAtom, windowSizeAtom } from '../../recoil/atom/counter';
import type { IWindowSizeState } from '../../recoil/atom/ICounterState';
import { getMarginSize, getPaperHeight, getRectSize } from '../../tools/calculator';
import llc from '../../tools/llc';

const log = llc(__filename);

const ResizeBox: React.FC = () => {
  const [windowSizeState, setWindowSizeState] = useRecoilState(windowSizeAtom);
  const [textLayoutState, setTextLayoutState] = useRecoilState(textLayoutAtom);
  // subject를 useEffect에 넣으면 windowSizeState가 변하면서 subject를 계속 건드려서 resizing이 매우 많이 발생하게 된다
  const subject = new Subject<Omit<IWindowSizeState, 'margin'>>();

  subject
    .pipe(throttleTime(100))
    .pipe(debounceTime(300))
    .pipe(filter((size) => size.height !== windowSizeState.height || size.width !== windowSizeState.width))
    .subscribe((newSize) => {
      log('윈도우 폭 변경: ', newSize.width, newSize.height);
      const size = getMarginSize({
        size: { width: windowSizeState.width, height: windowSizeState.height },
        letters: textLayoutState.letters,
      });

      const { widths, heights } = getRectSize({
        size: { width: size.width, height: newSize.height },
        letters: textLayoutState.letters,
        margin: size.margin,
      });

      setTextLayoutState({
        ...textLayoutState,
        character: {
          widths,
          heights,
          margin: size.margin,
        },
      });

      setWindowSizeState({
        ...windowSizeState,
        width: size.width,
        height: getPaperHeight(newSize.width),
      });
    });

  useEffect(() => {
    window.addEventListener('resize', () => {
      subject.next({ width: window.innerWidth, height: window.innerHeight });
    });

    setWindowSizeState({ ...windowSizeState, width: window.innerWidth, height: getPaperHeight(window.innerWidth) });
  }, []); // eslint-disable-line

  return <div style={{ display: 'none' }}></div>;
};

export default ResizeBox;
